import { Cookie, Header } from "~/types";
import {
  defaultHeaders,
  fetchClientConfig,
  fetchV4Home,
  SendOTPResult,
  sendOTPViaSMS,
  setAuth,
  setDefaultHeaders,
  submitOTP,
  SubmitOTPResult,
} from "../auth";
import { EventManager, HubbleEvent } from "../events";
import { setCookie } from "~/utils/client_cookie";
import { config } from "../config";
import { HubbleOTPAuth } from "~/screens/hubble_otp_auth/hubble_otp_auth";
import { HubbleRoute, pushPage } from "~/shared_states/modal";

export function logIntoHubble(
  afterLogin: () => void,
  eventManager: EventManager
) {
  const onPhoneSubmit = async (phoneNumber: string): Promise<SendOTPResult> => {
    return sendOTPViaSMS(phoneNumber);
  };

  const onOtpSubmit = async (
    phoneNumber: string,
    otp: string,
    otpToken: string
  ): Promise<SubmitOTPResult> => {
    return submitOTP(phoneNumber, otp, otpToken, false);
  };

  const onResendOtp = async (phoneNumber: string): Promise<SendOTPResult> => {
    return sendOTPViaSMS(phoneNumber);
  };

  const onOtpSuccess = async (
    phoneNumber: string,
    submitResult: SubmitOTPResult
  ): Promise<void> => {
    if (
      window.location.pathname == "/auth" ||
      window.location.pathname == "/login"
    ) {
      window.parent.postMessage(
        {
          type: "login",
          payload: {
            success: true,
            sid: submitResult.sessionId,
          },
        },
        "*"
      );
    }

    eventManager.sendEvent(HubbleEvent.LOGIN, {
      phoneNumber: phoneNumber,
    });

    setDefaultHeaders({
      ...defaultHeaders(),
      [Header.SessionId]: submitResult.sessionId,
    });

    setAuth(() => {
      return { sessionId: submitResult.sessionId } as any;
    });

    setCookie({
      key: Cookie.SessionId,
      value: submitResult.sessionId,
      expiryInMinutes: config.sesssionDurationInMinutes.webstore,
    });

    afterLogin();
  };

  pushPage(
    () => (
      <HubbleOTPAuth
        onPhoneSubmit={onPhoneSubmit}
        onOtpSubmit={onOtpSubmit}
        onResendOtp={onResendOtp}
        onOtpSuccess={onOtpSuccess}
        eventManager={eventManager}
        mode="hubble"
      />
    ),
    {
      isModal: true,
      disableCloseButton: true,
    },
    HubbleRoute.COLLECT_PHONE
  );
}
